<template>
  <div class="chart-box">
    <ul :style="{ right: legendRight + 'px' }" class="legend" v-if="chartData">
      <li :key="index" v-for="(item, index) in chartData">
        <div :style="{ background: colorList[index] }" class="rect"></div>
        <div class="name">{{ item.name }}</div>
        <div :style="{ color: colorList[index] }" class="proportion">
          {{ item.proportion + "%" }}
        </div>
      </li>
    </ul>
    <div
      :class="className"
      :id="id"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
export default {
  name: "PolarBar",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Array,
      default() {
        return [];
      }
    },
    colorList: {
      type: Array,
      default() {
        return ["#1d89ff", "#00cdff", "#4be8ca", "#eecf50", "#ff7352", "#fff"];
      }
    },
    legendRight: {
      type: Number,
      default: 20
    },
    centerX: {
      type: Number,
      default: 36
    },
    barWidth: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      let series = [];
      for (let i = 0; i < this.chartData.length; i++) {
        let temp = {
          type: "bar",
          data: [],
          coordinateSystem: "polar",
          barWidth: this.barWidth,
          barCategoryGap: 0,
          barGap: 0,
          itemStyle: {
            normal: {}
          },
          name: ""
        };
        temp.data[0] = this.chartData[i].proportion;
        temp.itemStyle.normal.color = this.colorList[i];
        temp.name = this.chartData[i].name;
        series.unshift(temp);
      }
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} : {c}%'
        },
        angleAxis: {
          show: false,
          inverse: true,
          max: 100
        },
        radiusAxis: {
          type: "category",
          show: false
        },
        polar: {
          center: [this.centerX + "%", "50%"]
        },
        series: series
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart-box {
  width: 100%;
  height: 100%;
  position: relative;
  .legend {
    position: absolute;
    z-index: 99;
    top: 50%;
    transform: translateY(-50%);
    li {
      width: 100%;
      height: 25px;
      font-size: 12px;
      margin: 6px 0;
      > div {
        float: left;
      }
      .rect {
        width: 12px;
        height: 12px;
        margin-top: 4px;
      }
      .name {
        margin: 0 16px 0 6px;
      }
      .proportion {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
}
</style>
